var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navigation'),_c('v-main',{staticClass:"main"},[_c('router-view')],1),_c('Awards'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }